export default __webpack_public_path__ + "static/media/arts_and_crafts.570c7f84.jpeg";